import { useState } from "react";
import type { BugReport } from "@/components/common/bugReportClient";

function statusBadgeClass(status: string) {
  if (status === "open") return "border-rose-300 bg-rose-50 text-rose-800";
  if (status === "in_progress") return "border-amber-300 bg-amber-50 text-amber-800";
  if (status === "resolved") return "border-emerald-300 bg-emerald-50 text-emerald-800";
  return "border-gray-300 bg-gray-100 text-gray-600";
}

export function BugReportMyTicketsList(props: {
  reports: BugReport[];
  reportsLoading: boolean;
  openCount: number;
}) {
  const { reports, reportsLoading, openCount } = props;
  const [showResolved, setShowResolved] = useState(false);
  const unresolved = reports.filter((r) => r.status === "open" || r.status === "in_progress");
  const resolved = reports.filter((r) => r.status === "resolved" || r.status === "wont_fix");

  return (
    <div className="border-t border-gray-100 px-4 py-3 space-y-2">
      <div className="text-xs font-medium text-gray-600">
        Your tickets
        {reportsLoading ? " …" : openCount > 0 ? ` (${openCount} open)` : ""}
      </div>
      {!reportsLoading && reports.length === 0 ? (
        <div className="text-xs text-gray-400">No tickets yet.</div>
      ) : null}
      {unresolved.slice(0, 5).map((r) => (
        <div key={r.id} className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 space-y-0.5">
          <div className="flex items-center gap-1.5">
            <span className={"rounded-full border px-1.5 py-0 text-[10px] font-medium " + statusBadgeClass(r.status)}>
              {r.status.replace("_", " ")}
            </span>
            {r.mode ? <span className="text-[10px] text-gray-400">{r.mode}</span> : null}
          </div>
          <div className="text-xs text-gray-700 line-clamp-2">{r.description}</div>
          {r.route_path || r.view_context ? (
            <div className="text-[10px] text-gray-400 line-clamp-1">
              {[r.view_context, r.route_path].filter(Boolean).join(" • ")}
            </div>
          ) : null}
          <div className="text-[10px] text-gray-400">{new Date(r.created_at).toLocaleDateString()}</div>
        </div>
      ))}
      {resolved.length ? (
        <div className="pt-1">
          <button
            type="button"
            className="text-[11px] text-gray-500 hover:text-gray-700"
            onClick={() => setShowResolved((previous) => !previous)}
          >
            {showResolved ? "Hide" : "Show"} resolved / closed ({resolved.length})
          </button>
        </div>
      ) : null}
      {showResolved
        ? resolved.slice(0, 5).map((r) => (
            <div key={r.id} className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 space-y-0.5 opacity-90">
              <div className="flex items-center gap-1.5">
                <span
                  className={
                    "rounded-full border px-1.5 py-0 text-[10px] font-medium " +
                    (r.status === "resolved"
                      ? "border-emerald-300 bg-emerald-50 text-emerald-800"
                      : "border-gray-300 bg-gray-100 text-gray-600")
                  }
                >
                  {r.status === "wont_fix" ? "won't fix" : "resolved"}
                </span>
                {r.mode ? <span className="text-[10px] text-gray-400">{r.mode}</span> : null}
              </div>
              <div className="text-xs text-gray-700 line-clamp-2">{r.description}</div>
              {r.resolution_summary ? (
                <div className="text-[11px] text-emerald-800">{r.resolution_summary}</div>
              ) : null}
              <div className="text-[10px] text-gray-400">
                {new Date(r.created_at).toLocaleDateString()}
                {r.resolved_at ? ` • closed ${new Date(r.resolved_at).toLocaleDateString()}` : ""}
              </div>
            </div>
          ))
        : null}
      {reports.length > 5 ? (
        <div className="text-[11px] text-gray-400">+{reports.length - 5} more in Dev panel</div>
      ) : null}
    </div>
  );
}
